//------------
// replace at
//------------
export default function replaceAt(str, indices, char) {
  console.log("----------------------");
  console.log("IN replaceAt");

  const arr = [...str]; // Convert string to array
  for (let j = 0; j < indices.length; j++) {
    let k = indices[j];
    arr[k] = char;
  }
  console.log("ARRAY = " + arr);
  return arr.join(""); // Back to string
}
